import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/movie", label: "电影分类" },
  { to: "/tv", label: "电视剧分类" },
  { to: "/news", label: "影视资讯" },
  { to: "/special", label: "评论专题" },
];

const helpLinks = [
  { to: "/search", label: "站内搜索" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-page px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg flex items-center justify-center bg-accent-500 text-foreground-950">
                <i className="ri-film-line text-lg" />
              </span>
              <span className="font-heading text-2xl tracking-wide text-background-50">
                影视工厂
              </span>
            </div>
            <p className="mt-5 text-sm leading-7 text-background-300">
              影视工厂是一个综合性影视内容平台，汇聚电影、电视剧的资讯、推荐与深度解读，
              致力于为影视爱好者、追剧观众与内容创作者提供丰富、权威、可视化的内容体验。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a href="https://weibo.com" target="_blank" rel="noreferrer" aria-label="微博" className="w-10 h-10 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-weibo-fill" />
              </a>
              <a href="https://www.douyin.com" target="_blank" rel="noreferrer" aria-label="抖音" className="w-10 h-10 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-music-2-line" />
              </a>
              <a href="https://www.bilibili.com" target="_blank" rel="noreferrer" aria-label="哔哩哔哩" className="w-10 h-10 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-tv-2-line" />
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-instagram-line" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 tracking-wide">
              <Link to="/">内容导航</Link>
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 tracking-wide">
              <Link to="/about">帮助与支持</Link>
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {helpLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li className="text-background-300">合作邮箱：hello@yingshigongchang.com</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 影视工厂 Yingshi Factory. 保留所有权利。</p>
          <p>本站为演示站点，站内影视内容均为虚构，仅供展示用途。</p>
        </div>
      </div>
    </footer>
  );
}